module.exports = __webpack_public_path__ + "static/media/19-12.5912ef32.mp3";